<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  name: 'OrderTypeModal',
  components: { },
  mounted () {
  },
  data () {
    return {
      module: this.$route.meta.module,
      headers: { 'Content-Type': 'text/rtf' }
    }
  },
  computed: {
    ...mapState('orders', {
      orderTypeModal: (state) => state.orderTypeModal
    }),
    ...mapState({
      detailsModal: (state) => state.shared.detailsModal
    }),
    ...mapGetters([
      'orderTypeOptions'
    ]),
    fileTypeInfo () {
      return `Only accepts ${this.fileExtensions} extensions`
    }
  },
  methods: {
    ...mapMutations('orders', [
      'openOrderType',
      'closeOrderType'
    ]),
    ...mapActions('orders', [
    ])
  }
}
</script>

<template>
  <q-modal v-model="orderTypeModal.open" class="" :content-css="{minWidth: '25vw', minHeight: '30vh'}">
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-icon name="" label="Order Type"></q-icon>
        <q-toolbar-title>
        </q-toolbar-title>
        <q-icon
          @click.native="onClose()"
          icon="clear"
        />
      </q-toolbar>
      <q-toolbar slot="footer">
        <q-toolbar-title>
          
        </q-toolbar-title>
        <q-btn label="Add" color="green"/>
      </q-toolbar>

      <div >
        <div>
          testing
        </div>
      </div>
    </q-modal-layout>
  </q-modal>
</template>

<style>
#upload-body {
  overflow: scroll
}
</style>
